module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fb-Gb-Hc-Ia.75ee8d28.png";